module.exports = __webpack_public_path__ + "media/app/assets/hero-background-6addb31f8106c0c413e899202843e271.png";